import * as tslib_1 from "tslib";
import * as React from 'react';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import { getFormattedDate } from 'owa-mail-store-actions';
import { observer } from 'mobx-react';
var styles = require('./ComposeBottom.scss');
var classNames = require('classnames/bind').bind(styles);
/**
 * Use this component to only draw Draft save time, so that when the time is changed, we don't need to rerender other components
 */
var DraftSaveTime = /** @class */ (function (_super) {
    tslib_1.__extends(DraftSaveTime, _super);
    function DraftSaveTime() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DraftSaveTime.prototype.render = function () {
        var draftSaveTime = this.props.viewState.lastSaveTimeStamp;
        var className = classNames(styles.draftSaveTime, {
            isHidden: !draftSaveTime,
        });
        // Use a placeholder here to occupy the space when there isn't an available time string
        // so that we don't need to always do remeasure when draft save time is changed
        draftSaveTime = draftSaveTime || new Date().toISOString();
        var draftSaveTimeString = getFormattedDate(draftSaveTime);
        return (React.createElement("div", { className: className }, draftSaveTimeString && format(strings.draftSavedTime, draftSaveTimeString)));
    };
    DraftSaveTime = tslib_1.__decorate([
        observer
    ], DraftSaveTime);
    return DraftSaveTime;
}(React.Component));
export default DraftSaveTime;
//# sourceMappingURL=DraftSaveTime.js.map